// actions types used in dashboard page are defined here
export const GET_PATIENT_APPOINTMENTS = 'GET_PATIENT_APPOINTMENTS';
export const GET_PATIENT_APPOINTMENTS_SUCCESS =
  'GET_PATIENT_APPOINTMENTS_SUCCESS';
export const GET_PATIENT_APPOINTMENTS_ERROR = 'GET_PATIENT_APPOINTMENTS_ERROR';

export const GET_DOCTOR_APPOINTMENTS = 'GET_DOCTOR_APPOINTMENTS';
export const GET_DOCTOR_APPOINTMENTS_SUCCESS =
  'GET_DOCTOR_APPOINTMENTS_SUCCESS';
export const GET_DOCTOR_APPOINTMENTS_ERROR = 'GET_DOCTOR_APPOINTMENTS_ERROR';

export const CANCEL_APPOINTMENTS = 'CANCEL_APPOINTMENTS';
export const CANCEL_APPOINTMENTS_SUCCESS = 'CANCEL_APPOINTMENTS_SUCCESS';
export const CANCEL_APPOINTMENTS_ERROR = 'CANCEL_APPOINTMENTS_ERROR';
